<template>
  <div>
    <div class="d-flex" id="wrapper">
        <!-- Sidebar -->
        <SideBar/>
        <!-- /#sidebar-wrapper -->
        <!-- Page Content -->
        <div id="page-content-wrapper">
            <nav style="justify-content:flex-start;" class="navbar navbar-expand-lg navbar-light bg-light border-bottom floating">
                <div>
                    <button class="btn btn-outline" id="menu-toggle" @click="sidebar"><span class="navbar-toggler-icon"></span>
                    </button>

                    <button style="color: rgba(0,0,0,.5);border-color: rgba(0,0,0,.1);" class="btn btn-outline navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <span style="padding-top:0.5em;"><i class="fas fa-user-alt"></i><span class="account-div"></span><i class="fas fa-angle-down"></i></span>
                    </button>
                </div>
                <div class="d-flex">
                    <!-- <i class="fas fa-home text-muted hover-cursor" @click="toPage('/dashboard')"></i> -->
                    <p class="text-muted mb-0 hover-cursor link" @click="toPage('/partnership/lessor')">&nbsp;Lessor&nbsp;</p>
                    <p class="text-primary mb-0 hover-cursor">/&nbsp;Details</p>
                </div>

                <div class="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul class="navbar-nav ml-auto mt-2 mt-lg-0">
                        <li class="nav-item dropdown">
                            <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    {{ admin }}
                  </a>
                            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
                                <a class="dropdown-item link" @click="toPage('/password')"> <i class="fas fa-cog"></i><span class="right-dropdown">Change Password</span></a>
                                <a class="dropdown-item link" @click="handleLogout"><i class="fas fa-sign-out-alt"></i><span class="right-dropdown">Logout</span></a>
                            </div>
                        </li>
                    </ul>
                </div>
            </nav>
            <div class="container-fluid">
                <div class="row mr-1">
                    <div class="col-md-12 grid-margin stretch-card card-div">
                        <div class="container">
                            <div class="row">
                                <div class="col-lg-5 col-md-5 col-sm-12">
                                    <table>
                                        <tr>
                                            <th colspan="3" class="py-2">
                                                <h5> Lessor Info <span class="link ml-2" @click="openModal('EditCompany')"><i class="fas fa-edit" data-toggle="tooltip" title="Edit"></i></span></h5>
                                            </th>
                                        </tr>
                                        <tr>
                                            <td>Lessor Name</td>
                                            <td>&emsp;:&emsp;</td>
                                            <td>{{ lessorName }}</td>
                                        </tr>
                                        <tr>
                                            <td class="align-top">Lessor Point Name</td>
                                            <td class="align-top">&emsp;:&emsp;</td>
                                            <td>{{ pointName }}</td>
                                        </tr>
                                        <tr>
                                            <td class="align-top">Point Address</td>
                                            <td class="align-top">&emsp;:&emsp;</td>
                                            <td>{{ pointAddress }}</td>
                                        </tr>
                                        <tr>
                                            <td class="align-top">Point Phone</td>
                                            <td class="align-top">&emsp;:&emsp;</td>
                                            <td>{{ pointPhone }}</td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mr-1">
                    <div class="col-md-12 grid-margin stretch-card card-div">
                        <div class="container">
                            <h5 class="card-title">Log Action</h5>
                            <div class="card" style="border: none;">
                              <div class="card-body" style="padding: 0px;">
                                <table class="fixed_header table-bordered table-striped">
                                  <tbody class="full-width">
                                    <tr>
                                      <th style="min-width: 150px;">When</th>
                                      <th style="min-width: 500px;">What</th>
                                      <th>Who</th>
                                    </tr>
                                    <tr v-if="dataLog.length == 0">
                                      <td colspan="3">Tidak ada Log</td>
                                    </tr>
                                    <tr v-else v-for="(data, index) in dataLog" :key="`log-${index}`">
                                      <td> {{ data.time }}</td>
                                      <td> {{ data.text }}</td>
                                      <td> {{ data.ids }}</td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                        </div>
                    </div>
                </div>
                 <div class="row mr-1 mt-5">
                    <div class="col-md-12 grid-margin stretch-card card-div">
                        <div class="container">
                            <div class="row">
                                <div class="container">
                                <div class="two-button text-center">
                                  <button class="btn btn-primary block" @click="switchPage(pointId, 'renting')">Renting</button>
                                  <button class="btn btn-outline-right block" @click="switchPage(pointId, 'rented')">Rented</button>
                                </div>
                                <div class="search-table container-fluid mt-4">
                                    <div class="row">
                                      <div class="col-lg-2 col-sm mobile-div">
                                        <input type="text" class="form-control search-company" v-model="searchCompanyName" placeholder="Company Name">
                                      </div>
                                      <div class="col-lg-2 col-sm mobile-div">
                                        <multiselect v-model="searchProduct" :options="selectProduct" select-label="" :allow-empty="true" deselect-label="" placeholder="Product Name"></multiselect>
                                      </div>
                                      <div class="col-lg-2 col-sm mobile-div">
                                        <multiselect v-model="searchBrand" :options="selectBrand" select-label="" :allow-empty="true" deselect-label="" placeholder="Brand"></multiselect>
                                      </div>
                                      <div class="col-lg-2 col-sm mobile-div">
                                        <multiselect v-model="searchModel" :options="selectModel" select-label="" :allow-empty="true" deselect-label="" placeholder="Model"></multiselect>
                                      </div>
                                      <div class="col-lg-2 col-sm mobile-div">
                                        <multiselect v-model="searchCategory" :options="selectCategory" select-label="" :allow-empty="true" deselect-label="" placeholder="Category"></multiselect>
                                      </div>
                                      <div class="col-lg-2 col-sm mobile-div">
                                        <button class="btn btn-primary search-button" @click="searchData"> Search </button>
                                      </div>
                                    </div>
                                  </div>
                                  <table class="table table-sm table-bordered table-striped table-responsive-sm">
                                    <thead>
                                      <tr>
                                        <th>Company Name</th>
                                        <th>Product</th>
                                        <th>Order ID</th>
                                        <th>Brand</th>
                                        <th>Model</th>
                                        <th>Qty</th>
                                        <th>Specification</th>
                                        <th>Category</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr v-if="loadingTable == true">
                                        <td colspan="8" class="text-center"><img src="~@/assets/images/load-button.gif"></td>
                                      </tr>
                                      <tr v-else-if="loadingTable == false && totalData == '0'">
                                        <td colspan="8" class="text-center">Data Not Available</td>
                                      </tr>
                                      <tr v-for="(data, index) in dataRenting" :key="`rent-${index}`" v-else>
                                        <td>{{ data.companyName }}</td>
                                        <td>{{ data.productName }}</td>
                                        <td>
                                            <span class="link-blue" @click="toDetail(data.orderId, data.orderCode, data.companyId)">
                                                {{ data.orderCode }}
                                            </span>
                                        </td>
                                        <td>{{ parsing(data.productDetail,'brand',data.productType) }}</td>
                                        <td>{{ parsing(data.productDetail,'model',data.productType) }}</td>
                                        <td>{{ data.Qty }}</td>
                                        <td>{{ parsing(data.productDetail,'spec',data.productType) }}</td>
                                        <td>{{ data.productCategory }}</td>
                                      </tr>
                                    </tbody>
                                  </table>
                                  <div id="wrapperr">
                                    <div id="c1">
                                      <div class="alignLeft total-data">
                                        Total Data {{ totalData }} 
                                      </div>
                                    </div>
                                    <div id="c2">
                                      <div class="pagination p8 alignRight">
                                        <ul>
                                          <a class="is-active link" @click="toDataPage(parseInt(currentPage)-1)" v-if="currentPage != 1"><li>{{'<'}}</li></a>
                                          <a class="page"><li>{{ currentPage }} of {{ totalPage }} page</li></a>
                                          <a class="is-active link" @click="toDataPage(parseInt(currentPage)+1)" v-if="currentPage != totalPage"><li>></li></a>
                                        </ul>
                                    </div>
                                  </div>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- /#page-content-wrapper -->
    </div>
    <!-- modalEditCompany -->
    <div class="modal fade" id="modalEditCompany" role="dialog">
        <div class="modal-dialog modal-dialog-centered">
            <!-- Modal content-->
            <div class="modal-content">
                <div class="modal-header">
                    <div class="change-title">
                        <h4 class="modal-title">Edit Lessor Info </h4>
                    </div>
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body">
                    <div class="one-line">
                        <label class="ol-label"> Lessor Name </label>
                        <label class="ol-titik2">:</label>
                        <multiselect v-model="editLessorInput" :options="selectLessor" label="lessorName" :allow-empty="false" deselect-label="" placeholder="Lessor" track-by="lessorName"></multiselect>
                    </div>
                    <div class="one-line" v-if="editLessorInput.lessorId == 'other'">
                        <label class="ol-label"> New Lessor </label>
                        <label class="ol-titik2">:</label>
                        <input type="text" name="name" class="form-control form-control-sm" v-model="editNewLessorName" placeholder="">
                    </div>
                    <div class="one-line">
                        <label class="ol-label"> Supplier Name</label>
                        <label class="ol-titik2">:</label>
                        <input type="text" name="name" class="form-control form-control-sm" v-model="editSupplierName" placeholder="">
                    </div>
                    <div class="one-line">
                        <label class="ol-label"> Supplier Address </label>
                        <label class="ol-titik2">:</label>
                        <textarea class="form-control form-control-sm" v-model="editSupplierAddress"> </textarea>
                    </div>
                    <div class="one-line">
                        <label class="ol-label"> Supplier Phone </label>
                        <label class="ol-titik2">:</label>
                        <input type="text" name="phone_number" class="form-control form-control-sm"  v-model="editSupplierPhone" @keypress="isNumber($event)" placeholder="">
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-primary btn-sm" @click="submitEditCompany" v-if="loadingButtonSave == false">Save</button>
                    <button type="button" class="btn btn-primary btn-sm" disabled v-else><img src="~@/assets/images/2.gif" style="height: 18px;">Save</button>
                </div>
            </div>
        </div>
    </div>
    <!-- endModal -->
    <!-- modalEditCompany -->
    <div class="modal fade" id="modalEditPIC" role="dialog">
        <div class="modal-dialog modal-dialog-centered">
            <!-- Modal content-->
            <div class="modal-content">
                <div class="modal-header">
                    <div class="change-title">
                        <h4 class="modal-title">Edit Person In Charge (PIC)</h4>
                    </div>
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body">
                    <div class="one-line">
                        <label class="ol-label"> Name </label>
                        <label class="ol-titik2">:</label>
                        <input type="text" name="qty" class="form-control form-control-sm">
                    </div>
                    <div class="one-line">
                        <label class="ol-label"> KTP Number </label>
                        <label class="ol-titik2">:</label>
                        <input type="text" name="qty" class="form-control form-control-sm">
                    </div>
                    <div class="one-line">
                        <label class="ol-label"> Phone </label>
                        <label class="ol-titik2">:</label>
                        <input type="text" name="qty" class="form-control form-control-sm">
                    </div>
                    <div class="one-line">
                        <label class="ol-label"> Email </label>
                        <label class="ol-titik2">:</label>
                        <input type="text" name="qty" class="form-control form-control-sm">
                    </div>
                    <div class="one-line">
                        <label class="ol-label"> Position </label>
                        <label class="ol-titik2">:</label>
                        <input type="text" name="qty" class="form-control form-control-sm">
                    </div>
                    <div class="one-line">
                        <label class="ol-label"> Division </label>
                        <label class="ol-titik2">:</label>
                        <input type="text" name="qty" class="form-control form-control-sm">
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-primary btn-sm">Save</button>
                </div>
            </div>
        </div>
    </div>
    <!-- endModal -->
    <!-- Modal Edit-->
    <div class="modal fade" id="modalDelete" role="dialog">
        <div class="modal-dialog modal-dialog-centered">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header">
              <div class="change-title">
                <h4 class="modal-title">Delete Admin</h4> 
              </div>
              <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
              <p>Are you sure to delete Admin (ini nama admin) ?</p>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal">Cancel</button>
              <button type="button" class="btn btn-primary btn-sm">Save</button>
            </div>
          </div>
        </div>
    </div>
    <!-- endModal -->
    <!-- modalReject -->
      <div class="modal fade" id="modalChangeDocument" role="dialog">
        <div class="modal-dialog modal-dialog-centered">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header">
              <div class="change-title">
                <h4 class="modal-title">Change Document {{ docPilih }}</h4> 
              </div>
              <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
              <div class="text-center">
              <img src="~@/assets/images/no-image.png" class="img-responsive" id="show_img_rent">
              </div>
              <input type="file" name="file_foto_rent" id="file_foto_rent" v-on:change="ValidateFileUpload">
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal">Cancel</button>
              <button type="button" class="btn btn-primary btn-sm">Change</button>
            </div>
          </div>
        </div>
      </div>
      <!-- endModal -->

      <!-- MODAL DOCUMENTS -->
      <!-- Modal DocPending-->
    <div class="modal fade" id="modalDocPending" role="dialog">
        <div class="modal-dialog modal-xl modal-dialog-centered">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header">
              <div class="change-title">
                <h4 class="modal-title">Document {{ docPilih }}</h4> 
              </div>
              <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
                <div class="mb-3">
                    <h5>History Documents</h5>
                    <table class="table table-sm table-bordered">
                        <tr>
                          <th>Status</th>
                          <th>Submit Date</th>
                          <th>Submit By</th>
                          <th>Action Date</th>
                          <th>Action By</th>
                          <th>Note</th>
                          <th>Files</th>
                        </tr>
                        <tr>
                          <td>Rejected</td>
                          <td>25-09-2019 13:00:00</td>
                          <td>Acep</td>
                          <td>30-09-2019 10:10:00</td>
                          <td>Zikri</td>
                          <td>Working not what what</td>
                          <td>donwload</td>
                        </tr>
                    </table>
                </div>
              <div class="one-line">
                <label class="ol-label-reason"> Status </label>
                <label class="ol-titik2">:</label>
                <select class="form-control form-control-sm">
                    <option value="">None</option>
                    <option value="1">Approve</option>
                    <option value="6">Reject</option>
                </select>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal">Cancel</button>
              <button type="button" class="btn btn-primary btn-sm">Save</button>
            </div>
          </div>
        </div>
    </div>
      <!-- endModal -->
  </div>
</template>

<script>
  import SideBar from '../SideBar'
  import Multiselect from 'vue-multiselect'
  import 'vue-multiselect/dist/vue-multiselect.min.css'
  export default {
    name: 'OrderDetailPage',
    components: {
      SideBar, Multiselect
    },
    data() {
      return {
        spaceRegex: /[\u00A0\uFEFF\u202F]/g,
        dataLog: [],
        province:[],
        kabkot:[],
        kecamatan:[],
        filterUser:'',
        dataOrder: [],
        dataRenting: [],
        columns: ['companyName', 'orderID'],
        totalPage:0,
        totalData:0,
        currentPage:1,
        viewDashboard: false,
        viewOrder: false,
        viewReturn: false,
        viewProduct: false,
        viewPairing: false,
        viewReconcile: false,
        viewResolution: false,
        viewLessor: false,
        viewLessee: false,
        viewEmployee: false,
        editOrder: false,
        editReturn: false,
        editProduct: false,
        editPairing: false,
        editReconcile: false,
        editResolution: false,
        editLessor: false,
        editLessee: false,
        editEmployee: false,
        loadingButtonSave:false,
        orderId:"",
        companyName:"",
        statusOrder:"",
        admin:"",
        adminId:"",
        inputs:[],
        assignDeposit:0,
        productOrder:[],
        Deposit:0,
        docPilih:"",
        loadingTable:true,
        lessorId:'',
        companyAddress:'',
        companyPhone:'',
        companyFax:'',
        companyId:'',
        editCompanyPhone:'',
        editCompanyAddress:'',
        editCompanyName:'',
        editProvince:'',
        editKabKot:'',
        editKecamatan:'',
        editKelurahan:'',
        editZip:'',
        apiProvince:'',
        apiKabKot:'',
        apiKecamatan:'',
        apiDataKecamatan:[],
        apiDataKabkot:[],
        companyProvince:'',
        companyDistrict:'',
        companyCity:'',
        companyVillage:'',
        companyZip:'',
        searchCompanyName:'',
        searchProduct:'',
        searchBrand:'',
        searchModel:'',
        searchCategory:'',
        selectProduct:[],
        selectBrand:[],
        selectModel:[],
        selectCategory:[],
        pointName:'',
        pointAddress:'',
        pointPhone:'',
        lessorName:'',
        pointId:'',
        editLessorInput:{
            lessorId:'',
            lessorName:'Choose Lessor'
        },
        selectLessor:[],
        selectLessorSearch:[],
        editNewLessorName:'',
        editSupplierName:'',
        editSupplierAddress:'',
        editSupplierPhone:'',
        searchLessor:{
            lessorId:'All',
            lessorName:'All'
        },
        logLessor: []
      }
    },
    methods: {
      isNumber: function(evt) {
          evt = (evt) ? evt : window.event;
          var charCode = (evt.which) ? evt.which : evt.keyCode;
          if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
            evt.preventDefault();;
          } else {
            return true;
          }
      },
        sendLog(x,y,z,a){
            var today = new Date();
            var month = today.getMonth()+1
            if (month < 10) {
                month = '0'+month
            }
            var dateDay = today.getDate()
            if (dateDay < 10) {
                dateDay = '0'+dateDay
            }
            var hours = today.getHours()
            if (hours < 10) {
                hours = '0'+hours
            }
            var minutes = today.getMinutes()
            if (minutes < 10) {
                minutes = '0'+minutes
            }
            var second = today.getSeconds()
            if (second < 10) {
                second = '0'+second
            }
            var date = today.getFullYear()+'-'+month+'-'+dateDay;
            var time = hours + ":" + minutes + ":" + second;
            var dateTime = date+' '+time;
            var admin = this.admin
            var command = 'add-logs'
            // var productName = this.productNameChoose
            console.log(process.env.LOG_URL+"/lessor/"+x)
            this.$http.post(process.env.LOG_URL+"/lessor/"+x,{
                codeLogs: y,
                params: [z, a],
            },{
                headers: {'Asani-Token':localStorage.getItem('jwt')}
            })
            .then(response => {
                this.connectLogLessor()
            })
            .catch(error => {
                console.log(error)
            })
        },
        connectLogLessor:function(){
            var pointId = this.pointId
            this.$http.get(process.env.LOG_URL+"/lessor/"+pointId,{
                headers: {'Asani-Token':localStorage.getItem('jwt')}
            })
            .then(response => {
                if (response.data.status === 200) {
                    this.dataLog = response.data.content
                }
            })
            .catch(error => {
                console.log(error)
            })
        },
        getLogLessor(data){
            this.logLessor = data
        },
        toDetail(id,orderCode,companyId){
          this.$router.push({path:'/order/detail/' + id, query: {
            orderCode: orderCode,
            companyIdDetail: companyId
          }
        })
        },
        parsing(x,y,z){
            if (y == 'brand') {
                return JSON.parse(x)["brand"]
            }else if (y == 'model') {
                return JSON.parse(x)["model"]
            }if (y == 'spec') {
                if (z == '1' || z == '2') {
                    return JSON.parse(x)["processor"]+'/'+JSON.parse(x)["vga"]+'/'+JSON.parse(x)["ram"]+'GB/'+JSON.parse(x)["storage"]
                }else if (z == '3') {
                    return JSON.parse(x)["screen"]+' Inch'
                }
            }
        },
        submitEditCompany(){
              if (this.editLessorInput.lessorId== 'other') {
                if (this.editNewLessorName == '') {
                    swal("Sorry", "New lessor must be fill", "error", {
                      button: "Ok",
                    })
                }else if (this.editSupplierName == '') {
                    swal("Sorry", "Supplier name must be fill", "error", {
                      button: "Ok",
                    })
                }else if (this.editSupplierAddress == '') {
                    swal("Sorry", "Supplier address must be fill", "error", {
                      button: "Ok",
                    })
                }else if (this.editSupplierPhone == '') {
                    swal("Sorry", "Supplier phone must be fill", "error", {
                      button: "Ok",
                    })
                }else{
                    this.loadingButtonSave = true
                    this.$http.post(process.env.EDIT_LESSOR,{
                      lessorIdBefore: this.lessorId,
                      lessorId: this.editLessorInput.lessorId,
                      pointId: this.pointId,
                      newLessor: this.editNewLessorName !== null ? this.editNewLessorName.replace(this.spaceRegex, ' ') : this.editNewLessorName,
                      supplierName: this.editSupplierName !== null ? this.editSupplierName.replace(this.spaceRegex, ' ') : this.editSupplierName,
                      supplierAddress: this.editSupplierAddress !== null ? this.editSupplierAddress.replace(this.spaceRegex, ' ') : this.editSupplierAddress,
                      supplierPhone: this.editSupplierPhone !== null ? this.editSupplierPhone.replace(this.spaceRegex, ' ') : this.editSupplierPhone
                    },{
                      headers: {'Asani-Token':localStorage.getItem('jwt')}
                    })
                    .then(response => {
                      if (response.data.status == 400) {
                          swal("Sorry", response.data.message , "error", {
                            button: "Ok",
                          })
                          $('#modalEditCompany').modal('hide')
                      }else if (response.data.status == 201) {
                          swal("Sorry", response.data.message , "error", {
                            button: "Ok",
                          })
                      }else if (response.data.status == 200) {
                          swal("Success", response.data.message , "success", {
                            button: "Ok",
                          })
                          if (response.data.content.changeName == true) {
                            this.sendLog(this.pointId,42,response.data.content.oldPointName,response.data.content.newPointName)
                          }
                          if (response.data.content.changeLessor == true) {
                            this.sendLog(this.pointId,41,response.data.content.oldLessorName,response.data.content.newLessorName)
                          }
                          if (response.data.content.changeAddress == true) {
                            this.sendLog(this.pointId,43,response.data.content.oldAddress,response.data.content.newAddress)
                          }
                          if (response.data.content.changePhone == true) {
                            this.sendLog(this.pointId,44,response.data.content.oldPhone,response.data.content.newPhone)
                          }
                          this.editLessorInput = ({
                            lessorId:'',
                            lessorName:'Choose Lessor'
                          })
                          this.getData()
                          this.editNewLessorName = ''
                          this.editSupplierName = ''
                          this.editSupplierAddress = ''
                          this.editSupplierPhone = ''
                          $('#modalEditCompany').modal('hide')
                      }
                      this.loadingButtonSave = false
                    })
                    .catch(error => {
                      swal("Sorry", error.response.data.message, "error", {
                        button: "Ok",
                      }).then(v => {
                        if(error.response.data.status == 401) {
                          this.handleLogout()
                        }
                      })
                    }) 
                }
              }else{
                if (this.editLessorInput.lessorId == '') {
                    swal("Sorry", "Lessor must be choose", "error", {
                      button: "Ok",
                    })
                }else if (this.editSupplierName == '') {
                    swal("Sorry", "Supplier name must be fill", "error", {
                      button: "Ok",
                    })
                }else if (this.editSupplierAddress == '') {
                    swal("Sorry", "Supplier address must be fill", "error", {
                      button: "Ok",
                    })
                }else if (this.editSupplierPhone == '') {
                    swal("Sorry", "Supplier phone must be fill", "error", {
                      button: "Ok",
                    })
                }else{
                    this.loadingButtonSave = true
                    this.$http.post(process.env.EDIT_LESSOR,{
                      lessorIdBefore: this.lessorId,
                      lessorId: this.editLessorInput.lessorId,
                      pointId: this.pointId,
                      newLessor: this.editNewLessorName !== null ? this.editNewLessorName.replace(this.spaceRegex, ' ') : this.editNewLessorName,
                      supplierName: this.editSupplierName !== null ? this.editSupplierName.replace(this.spaceRegex, ' ') : this.editSupplierName,
                      supplierAddress: this.editSupplierAddress !== null ? this.editSupplierAddress.replace(this.spaceRegex, ' ') : this.editSupplierAddress,
                      supplierPhone: this.editSupplierPhone !== null ? this.editSupplierPhone.replace(this.spaceRegex, ' ') : this.editSupplierPhone
                    },{
                      headers: {'Asani-Token':localStorage.getItem('jwt')}
                    })
                    .then(response => {
                      if (response.data.status == 400) {
                          swal("Sorry", response.data.message , "error", {
                          button: "Ok",
                          })
                          $('#modalEditCompany').modal('hide')
                      }else if (response.data.status == 201) {
                          swal("Sorry", response.data.message , "error", {
                          button: "Ok",
                          })
                      }else if (response.data.status == 200) {
                          swal("Success", response.data.message , "success", {
                            button: "Ok",
                          })
                          if (response.data.content.changeName == true) {
                            this.sendLog(this.pointId,42,response.data.content.oldPointName,response.data.content.newPointName)
                          }
                          if (response.data.content.changeLessor == true) {
                            this.sendLog(this.pointId,41,response.data.content.oldLessorName,response.data.content.newLessorName)
                          }
                          if (response.data.content.changeAddress == true) {
                            this.sendLog(this.pointId,43,response.data.content.oldAddress,response.data.content.newAddress)
                          }
                          if (response.data.content.changePhone == true) {
                            this.sendLog(this.pointId,44,response.data.content.oldPhone,response.data.content.newPhone)
                          }
                          this.getData()
                          this.editLessorInput = ({
                            lessorId:'',
                            lessorName:'Choose Lessor'
                          })
                          this.editNewLessorName = ''
                          this.editSupplierName = ''
                          this.editSupplierAddress = ''
                          this.editSupplierPhone = ''
                          $('#modalEditCompany').modal('hide')
                      }
                      this.loadingButtonSave = false
                    })
                    .catch(error => {
                      swal("Sorry", error.response.data.message, "error", {
                        button: "Ok",
                      }).then(v => {
                        if(error.response.data.status == 401) {
                          this.handleLogout()
                        }
                      })
                    }) 
                }
              }
        },
        getKabkot(x){
            this.$http.post(process.env.API_GET_KABKOT, {
                provinceId: this.editProvince.provinceId,
            },{
              headers: {'Asani-Token':localStorage.getItem('jwt')}
            })
            .then(response => {
                if (response.data.status == 200) {
                    this.kabkot = response.data.content
                    if (x == 'ada') {
                        this.editKabKot = ''
                        this.editKecamatan = ''
                    }
                }
            })
            .catch(error => {
              swal("Sorry", error.response.data.message, "error", {
                button: "Ok",
              }).then(v => {
                if(error.response.data.status == 401) {
                  this.handleLogout()
                }
              })
            })
        },
        getKecamatan(x) {
            this.$http.post(process.env.API_GET_KECAMATAN, {
                kabKotId: this.editKabKot.kabKotId,
            },{
              headers: {'Asani-Token':localStorage.getItem('jwt')}
            })
            .then(response => {
                if (response.data.status == 200) {
                    this.kecamatan = response.data.content
                    if (x == 'ada') {
                        this.editKecamatan = ''
                    }
                }
            })
            .catch(error => {
              swal("Sorry", error.response.data.message, "error", {
                button: "Ok",
              }).then(v => {
                if(error.response.data.status == 401) {
                  this.handleLogout()
                }
              })
            })
        },
      switchPage(id,page){
        this.$router.push('/partnership/lessor/'+page+'/detail/' + id)
      },
      ValidateFileUpload() {
        var fuData = document.getElementById('file_foto_rent');
        var FileUploadPath = fuData.value;

        if (FileUploadPath == '') {
          alert("Please upload an image");

        } else {
          var Extension = FileUploadPath.substring(
            FileUploadPath.lastIndexOf('.') + 1).toLowerCase();

          if (Extension =="png" || Extension =="jpg") {
            if (fuData.files && fuData.files[0]) {
              var reader = new FileReader();

              reader.onload = function(e) {
                $('#show_img_rent').attr('src', e.target.result);
              }
              reader.readAsDataURL(fuData.files[0]);
            }
          }else {
            alert("Photo only allows file types of PNG.");
            document.getElementById("file_foto_rent").value ="";
                  // document.getElementById("show_img_"+index).src = './images/no-image-icon-23485.png';
          }
        }
      },
      addRow() {
        this.inputs.push({
          one: '',
          two: ''
        })
      },
      cekHaveDeposit() {
        var x = document.getElementById("haveDeposit").checked
        if (x) {
          this.assignDeposit = 1
        }else{
          this.assignDeposit =0
        }
      },
      openModal(x,y) {
        this.docPilih = y
        if(x == 'EditCompany'){
                this.editProvince = this.apiProvince
                if (this.editProvince != '') {
                    this.getKabkot()                    
                }
                this.editKabKot = this.apiKabKot
                this.kabkot = this.apiDataKabkot
                if (this.editKabKot != '') {
                    this.getKecamatan()
                }
                this.editKecamatan = this.apiKecamatan
                this.kecamatan = this.apiDataKecamatan
        }
        $("#modal"+x).modal('show')
      },
      viewAll(x){
        this.$router.push('/order/search')
        localStorage.setItem('companyName', x)
        localStorage.setItem('orderId',"")
        localStorage.setItem('statusOrder',"")
      },
      toDataPage(pagePost){
        if (this.searchProduct == null) {
                this.searchProduct = ''
            }
            if (this.searchCategory == null) {
                this.searchCategory = ''
            }
            if (this.searchModel == null) {
                this.searchModel = ''
            }
            if (this.searchBrand == null) {
                this.searchBrand = ''
            }       
            this.$router.push({path:'/partnership/lessor/renting/detail/' + this.pointId+'/search', query: {
                    companyName: this.searchCompanyName,
                    productName: this.searchProduct,
                    productCategory: this.searchCategory,
                    productModel: this.searchModel,
                    productBrand: this.searchBrand,
                    page: pagePost
                  }
            })
      },
      toPage(e) {
        this.$router.push(e)
      },
      cek(e) {
        console.log(this.statusOrder+'ini')
      },
      cekLogin(){
        if (localStorage.getItem('jwt') == null) {
          this.$router.push('/')
        }
      },
      cekPermission(){
      this.permission = localStorage.getItem('roles').replace(/"/g,"").replace("[","").replace("]","").split(",")
      for(var i=0; i < this.permission.length; i++){
        if( this.permission[i] == "1"){
          this.viewDashboard = true
        }
        if( this.permission[i] == "2.1"){
          this.viewOrder = true
        }
        if( this.permission[i] == "2.2"){
          this.editOrder = true
        }
        if( this.permission[i] == '3.1'){
          this.viewReturn = true
        }
        if( this.permission[i] == '3.2'){
          this.editReturn = true
        }
        if( this.permission[i] == '4.1'){
          this.viewProduct = true
        }
        if( this.permission[i] == '4.2'){
          this.editProduct = true
        }
        if( this.permission[i] == '5.1'){
          this.viewPairing = true
        }
        if( this.permission[i] == '5.2'){
          this.editPairing = true
        }
        if( this.permission[i] == '6'){
          this.viewReconcile = true
        }
        if( this.permission[i] == '7.1'){
          this.viewResolution = true
        }
        if( this.permission[i] == '7.2'){
          this.editResolution = true
        }
        if( this.permission[i] == '8.1'){
          this.viewLessor = true
        }
        if( this.permission[i] == '8.2'){
          this.editLessor = true
        }
        if( this.permission[i] == '9.1'){
          this.viewLessee = true
        }
        if( this.permission[i] == '9.2'){
          this.editLessee = true
        }
        if( this.permission[i] == '10'){
          this.viewEmployee = true
        }
      }
      if (this.viewLessor == false) {
        this.$router.push('/')
      }
    },
      async handleLogout() {
      try {
        const response = await this.$http.post(process.env.LOGOUT, {}, {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        if (response.data.status !== 200) {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
          })
          return
        }

      } catch (error) {
        if(error.response.data.status != 401) {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          })
          return
        }
      }
        localStorage.removeItem('jwt')
        localStorage.removeItem('admin_name')
        localStorage.removeItem('roles')
        localStorage.removeItem('user_email')
        localStorage.removeItem('admin_id')
        localStorage.removeItem('changeCatalogPermission')
        this.$router.push('/')
      },
      sidebar(){
        $("#wrapper").toggleClass("toggled");
      },
      close() {
        this.$emit('close');
      },
      cekInput(){

      },
      searchData(){
            if (this.searchProduct == null) {
                this.searchProduct = ''
            }
            if (this.searchCategory == null) {
                this.searchCategory = ''
            }
            if (this.searchModel == null) {
                this.searchModel = ''
            }
            if (this.searchBrand == null) {
                this.searchBrand = ''
            }       
            this.$router.push({path:'/partnership/lessor/renting/detail/' + this.pointId+'/search', query: {
                    companyName: this.searchCompanyName,
                    productName: this.searchProduct,
                    productCategory: this.searchCategory,
                    productModel: this.searchModel,
                    productBrand: this.searchBrand,
                    page: 1
                  }
            })
      },
      getData(){
        this.pointId = this.$route.params.lessorId
        this.$http.post(process.env.GET_DETAIL_LESSOR,{
              pointId: this.pointId
            },{
              headers: {'Asani-Token':localStorage.getItem('jwt')}
            })
          .then(response => {
            if (response.data.status == 400) {
                swal("Sorry", response.data.message , "error", {
                    button: "Ok",
                })
            }else{
                this.lessorName = response.data.content.detailLessor[0].lessorName
                this.pointName = response.data.content.detailLessor[0].pointName
                this.pointPhone = response.data.content.detailLessor[0].pointPhone
                this.pointAddress = response.data.content.detailLessor[0].pointAddress
                this.lessorId = response.data.content.detailLessor[0].lessorId
                this.editLessorInput.lessorId=response.data.content.detailLessor[0].lessorId
                this.editLessorInput.lessorName=response.data.content.detailLessor[0].lessorName
                this.editSupplierName = this.pointName
                this.editSupplierPhone = this.pointPhone
                this.editSupplierAddress = this.pointAddress
            }
          })
          .catch(error => {
            swal("Sorry", error.response.data.message, "error", {
              button: "Ok",
            }).then(v => {
              if(error.response.data.status == 401) {
                this.handleLogout()
              }
            })
          })

          this.$http.get(process.env.GET_ALL_LESSOR
          ,{
            headers: {'Asani-Token':localStorage.getItem('jwt')}
          })
          .then(response => {
              if (response.data.status == 200) {
                  this.selectLessorSearch=[]
                  this.selectLessorSearch.push({
                    lessorId:'All',
                    lessorName:'All'
                  })
                  for (var i = 0; i < response.data.content.length; i++) {
                    this.selectLessorSearch.push({
                      lessorId: response.data.content[i].lessorId,
                      lessorName: response.data.content[i].lessorName
                    }) 
                  }
                  this.selectLessor=[]
                  this.selectLessor = response.data.content
                  this.selectLessor.push({
                    lessorId:'other',
                    lessorName:'Other'
                  })
              }
          })
          .catch(error => {
            swal("Sorry", error.response.data.message, "error", {
              button: "Ok",
            }).then(v => {
              if(error.response.data.status == 401) {
                this.handleLogout()
              }
            })
          })

          this.$http.post(process.env.GET_LESSOR_RENTING,{
              pointId: this.pointId,
              page: 1
            },{
              headers: {'Asani-Token':localStorage.getItem('jwt')}
            })
          .then(response => {
            this.dataRenting = response.data.content.lessorRenting
            this.totalData = response.data.content.totalData
            this.totalPage = response.data.content.totalPage
            this.loadingTable =false

          })
          .catch(error => {
            swal("Sorry", error.response.data.message, "error", {
              button: "Ok",
            }).then(v => {
              if(error.response.data.status == 401) {
                this.handleLogout()
              }
            })
          })

          this.$http.post(process.env.GET_LESSOR_SEARCH,{
              pointId: this.pointId
            },{
              headers: {'Asani-Token':localStorage.getItem('jwt')}
            })
          .then(response => {
            this.selectProduct = response.data.content.productName
            this.selectBrand = response.data.content.productBrand
            this.selectModel = response.data.content.productModel
            this.selectCategory = response.data.content.productCategory
          })
          .catch(error => {
            swal("Sorry", error.response.data.message, "error", {
              button: "Ok",
            }).then(v => {
              if(error.response.data.status == 401) {
                this.handleLogout()
              }
            })
          })

        // this.$http.get(process.env.API_GET_PROVINCE
        //     ,{
        //       headers: {'Asani-Token':localStorage.getItem('jwt')}
        //     })
        //     .then(response => {
        //         if (response.data.status == 200) {
        //             this.province = response.data.content
        //         }
        //     })
        //     .catch(error => {
        //         console.log(error)
        //     })
      }
    },
    created(){
      this.getData()
      this.admin = localStorage.getItem('admin_name')
      this.adminId = localStorage.getItem('admin_id')
      this.cekLogin()
      this.cekPermission()
      this.connectLogLessor()
    }
  }
</script>

<!-- Add"scoped" attribute to limit CSS to this component only -->
<style scoped>
.link-blue{
    color: #2797FB;
    font-style: italic;
}

.link-blue:hover{
    cursor: pointer;
}

.btn-outline-right{
  border:1px solid black;
  border-left: none;
}

.btn-outline-left{
  border:1px solid black;
  border-right: none;
}

.two-button{
  display: flex;
  box-shadow: 2px;
  width: 100%;
}

.block {
  display: block;
  width: 100%;
  font-size: 16px;
  cursor: pointer;
  text-align: center;
  border-radius: 0px;
}

.edit-status{
    margin-bottom: 0
}
.permonth{ 
  margin: 5px 0px 5px 5px;
}
.text-partnership{
  margin-bottom: 0px;
}

.img-responsive{
  width: 250px;
  height: auto;
}

.process-vendor-new{
  max-width: 345px;
  margin: 5px 5px;
}

.process-qty-new{
  max-width: 62px;
  margin: 5px 5px;
}

.process-vendor{
  min-width: 345px;
  margin-bottom: 5px;
}

.process-qty{
  max-width: 62px;
}

.button-plus {
    position: absolute;
    bottom: 21px;
    right: 0px;
}

.input-title{
  margin: 0px 5px;
}

.input-one-line{
  display: flex;
}

.input-one-line-assign{
  display: flex;
  width: 100%;
}

.input-title-assign{
  margin: 0px 5px;
  width: 100%;
}

.input-title-qty{
  margin: 0px 5px;
  width: 100%;
}

.title-product{
  width: 100%;
  margin: 5px 0px;
}

.input-group-addon {
    padding: 6px 12px;
    font-size: 14px;
    font-weight: 400;
    line-height: 1;
    color: #555;
    text-align: center;
    background-color: #eee;
    border: 1px solid #ccc;
    border-radius: 4px 0px 0px 4px;
    border-right: none;
}

.label-addon-rp{
  margin: 1px 0px;
}

.change-title{
  display: block;
}

.one-line{
  display: flex;
  margin: 5px 0px;
}

.one-line .ol-label{
  width: 188px;
  margin: 2px 0px;
}

.one-line .ol-label-reason{
  width: 88px;
  margin: 2px 0px;
}

.search-company{
    height: 42px;
}

.search-button{
    height: 42px;
}

.one-line .ol-label-price{
  width: 263px;
  margin: 2px 0px;
}

.one-line .ol-titik2{
  width: 15px;
  margin: 2px 0px;
}

.one-line .ol-titik2-price{
  margin: 2px 0px;
}

.one-line .ol-value{
  width: 100%;
  margin: 2px 0px;
}

.fixed_header{
  table-layout: fixed;
  border-collapse: collapse;
}

.fixed_header tbody{
  display:block;
  overflow:auto;
  height:200px;
  width:100%;
}

.fixed_header tbody.full-width tr td{
  width:1578px;
}

.fixed_header thead tr{
  display:block;
}

.fixed_header th, .fixed_header td {
  padding: 5px;
  text-align: left;
  width: 200px;
}

.fixed_header.payment th, .fixed_header.payment td {
  padding: 5px;
  text-align: left;
  width: 217px;
}

.pagination{
  padding: 0px 0;
}

.pagination ul{
  margin: 0;
  padding: 0;
  list-style-type: none;
}

.pagination a{
  display: inline-block;
  padding: 1px 6px;
  color: #222;
}

.p8 a{
  background-color: #2797FB;
  /*margin: auto 5px;*/
  color: #fff;
  /*font-weight: bold;*/
  border: 1px solid #2797FB;
}

.p8 a:hover{
  text-decoration: none;
}
.p8 a.page:hover{
  text-decoration: none;
  color: #fff;
}

.p8 .is-active{
  background-color: #fff;
  color: #2797FB;
}

.alignleft {
  float: left;
}
.alignright {
  float: right;
}

.pagg{
  display: inline-flex;
  overflow:auto;
}

.total-data{
  font-size: 14px;
  color: #343A40;
}
#wrapperr{
  overflow:auto;
  margin: 5px 3px;
}

#c1{
 float:left;
}

#c2{
  float: right;  
}

/*.table td, .table th {
    padding: 0.25rem;
    vertical-align: top;
    border-top: 1px solid #dee2e6;
    }*/
    .search-table{
      padding-bottom: 7px;
      margin-top: -5px;
      margin-left: -15px;
    }
    .active{
      color: #2797FB;
    }
    .right-dropdown{
      margin-left: 7px;
    }
    .account-div{
      margin: 2px 2px;
    }
    .right-arrow{
      margin-left: auto;
    }
    .brand-logo{
      width: 120px;
    }
    .menu-title{
      margin-left: 1.125rem;
    }
    .menu-title-order{
      margin-left: 1.95rem;
    }
    .menu-title-payment{
      margin-left: 1.525rem;
    }

    ul {
      list-style-type: none;
      margin: 0;
      padding: 0;
      /*width: 200px;*/
      /*background-color: #f1f1f1;*/
    }

    li.sidebar a {
      display: block;
      color: #000;
      padding: 8px 63px;
      text-decoration: none;
    }

    li a.active {
      background-color: #4CAF50;
      color: white;
    }

    li a:hover:not(.active) {
      background-color: #2797FB;
      color: white;
    }
    .nav-side-menu {
      overflow: auto;
      font-family: verdana;
      font-size: 12px;
      font-weight: 200;
      background-color: #2e353d;
      position: fixed;
      top: 0px;
      width: 300px;
      height: 100%;
      color: #e1ffff;
    }
    .nav-side-menu .brand {
      background-color: #23282e;
      line-height: 50px;
      display: block;
      text-align: center;
      font-size: 14px;
    }
    .nav-side-menu .toggle-btn {
      display: none;
    }
    .nav-side-menu ul,
    .nav-side-menu li {
      list-style: none;
      padding: 0px;
      margin: 0px;
      line-height: 35px;
      cursor: pointer;
    }
    .nav-side-menu ul :not(collapsed) .arrow:before,
    .nav-side-menu li :not(collapsed) .arrow:before {
      font-family: FontAwesome;
      content:"\f078";
      display: inline-block;
      padding-left: 10px;
      padding-right: 10px;
      vertical-align: middle;
    }
    .nav-side-menu ul .active,
    .nav-side-menu li .active {
      border-left: 3px solid #d19b3d;
      background-color: #4f5b69;
    }
    .nav-side-menu ul .sub-menu li.active,
    .nav-side-menu li .sub-menu li.active {
      color: #d19b3d;
    }
    .nav-side-menu ul .sub-menu li.active a,
    .nav-side-menu li .sub-menu li.active a {
      color: #d19b3d;
    }
    .nav-side-menu ul .sub-menu li,
    .nav-side-menu li .sub-menu li {
      background-color: #181c20;
      border: none;
      line-height: 28px;
      border-bottom: 1px solid #23282e;
      margin-left: 0px;
    }
    .nav-side-menu ul .sub-menu li:hover,
    .nav-side-menu li .sub-menu li:hover {
      background-color: #020203;
    }
    .nav-side-menu ul .sub-menu li:before,
    .nav-side-menu li .sub-menu li:before {
      font-family: FontAwesome;
      content:"\f105";
      display: inline-block;
      padding-left: 10px;
      padding-right: 10px;
      vertical-align: middle;
    }
    .nav-side-menu li {
      padding-left: 0px;
      border-left: 3px solid #2e353d;
      border-bottom: 1px solid #23282e;
    }
    .nav-side-menu li a {
      text-decoration: none;
      color: #e1ffff;
    }
    .nav-side-menu li a i {
      padding-left: 10px;
      width: 20px;
      padding-right: 20px;
    }
    .nav-side-menu li:hover {
      border-left: 3px solid #d19b3d;
      background-color: #4f5b69;
      -webkit-transition: all 1s ease;
      -moz-transition: all 1s ease;
      -o-transition: all 1s ease;
      -ms-transition: all 1s ease;
      transition: all 1s ease;
    }
    @media (max-width: 767px) {
      .nav-side-menu {
        position: relative;
        width: 100%;
        margin-bottom: 10px;
      }
      .nav-side-menu .toggle-btn {
        display: block;
        cursor: pointer;
        position: absolute;
        right: 10px;
        top: 10px;
        z-index: 10 !important;
        padding: 3px;
        background-color: #ffffff;
        color: #000;
        width: 40px;
        text-align: center;
      }
      .brand {
        text-align: left !important;
        font-size: 22px;
        padding-left: 20px;
        line-height: 50px !important;
      }
    }
    @media (min-width: 767px) {
      .nav-side-menu .menu-list .menu-content {
        display: block;
      }
    }
    @media (max-width: 573px){
      .mobile-div{
        padding: 2px 0px;
      }
    }
  </style>



// WEBPACK FOOTER //
// src/components/Partnership/LessorDetailRentingPage.vue